export default {
  namespaced: true,
  actions: {
    create({ commit }, languageProficiency) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.post('admin/language_proficiencies', { languageProficiency })
    },
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/language_proficiencies/${id}`)
    }
  }
}
